import { Component } from 'react';
import I18n from 'I18n';
import PropTypes from 'prop-types';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UISelect from 'UIComponents/input/UISelect';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { jsx as _jsx } from "react/jsx-runtime";
const toI18nText = name => I18n.text(`draftPlugins.linkPlugin.${name}`);
const promptTextCreator = () => toI18nText('promptText');
const isNotCustomOption = option => !(option.className && option.className === 'Select-create-option-placeholder');
const isOptionUnique = ({
  options,
  valueKey
}) => {
  // options added via the "add option" functionality do not have a "help" field
  // this allows "add option" for links that are substrings of user-added options
  const pageOptionsOnly = options.filter(isNotCustomOption);

  // override default to make sure that promptText isn't added to possible options
  if (pageOptionsOnly.length === 1 && pageOptionsOnly[0][valueKey] === promptTextCreator()) {
    return true;
  } else if (pageOptionsOnly.length >= 1) {
    return false;
  }
  return true;
};
const RenderValue = ({
  value
}) => {
  return /*#__PURE__*/_jsx(UITruncateString, {
    className: "width-95",
    children: value
  });
};
RenderValue.propTypes = {
  value: PropTypes.string
};
export default class LinkFormPagesSelector extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      inputValue: this.props.url
    };
    this.handleInputChange = ({
      target
    }) => {
      this.setState({
        inputValue: target.value || ''
      });
    };
    this.handlePagesChange = ({
      target
    }) => {
      const {
        onChange
      } = this.props;
      const {
        value
      } = target;
      const result = {
        url: value || ''
      };
      if (this.previousSelectionFromPagesOrBlank()) {
        result.text = this.updateTextForPagesChange(value) || '';
      }
      this.setState({
        inputValue: result.url
      });
      onChange(result);
    };
    this.previousSelectionFromPagesOrBlank = () => {
      const {
        pages,
        showText,
        text,
        url
      } = this.props;
      return showText && (!text || pages.find(p => p.value === url && p.text === text));
    };
    this.updateTextForPagesChange = value => {
      const {
        pages
      } = this.props;
      if (!value) {
        return '';
      }
      const matchedPage = pages.find(p => p.value === value);
      if (matchedPage && matchedPage.text) {
        return matchedPage.text;
      }
      return value;
    };
  }
  render() {
    const {
      pages
    } = this.props;
    return /*#__PURE__*/_jsx(UIFormControl, {
      label: toI18nText('url'),
      children: /*#__PURE__*/_jsx(UISelect, {
        allowCreate: true,
        anchorType: "input",
        clearable: true,
        inputValue: this.state.inputValue
        // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
        ,
        isOptionUnique: isOptionUnique,
        onChange: this.handlePagesChange,
        onInputValueChange: this.handleInputChange,
        options: pages,
        placeholder: toI18nText('yourPagesPlaceholder'),
        promptTextCreator: promptTextCreator,
        valueRenderer: RenderValue
      })
    });
  }
}
LinkFormPagesSelector.propTypes = {
  onChange: PropTypes.func.isRequired,
  pages: PropTypes.array.isRequired,
  showText: PropTypes.bool,
  text: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired
};
LinkFormPagesSelector.defaultProps = {
  pages: [],
  showText: true
};